/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Plan_First_Meeting_ActionInputs */



/**
* | output |
* | --- |
* | "Add your first conversation" |
*
* @param {Nudge_Plan_First_Meeting_ActionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_plan_first_meeting_action = /** @type {((inputs?: Nudge_Plan_First_Meeting_ActionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Plan_First_Meeting_ActionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Eerste gesprek toevoegen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter ma première conversation")
	return /** @type {LocalizedString} */ ("Add your first conversation")
});